export function isMacOS() {
  const uaData = (navigator as any).userAgentData;
  if (uaData?.platform) {
    return uaData.platform === "macOS";
  }
  return /Macintosh|Mac OS X/.test(navigator.userAgent);
}

export function formatShortcut(keys: { mac: string; win: string }) {
  return isMacOS() ? keys.mac : keys.win;
}
